import { useAuthorization } from '@autone/auth';
import { useAutoneTranslation } from '@autone/translations';
import { HUB_READONLY } from '@autone/utils';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useMemo } from 'react';

import { ElementsIcon } from '../../../../icons';
import { useNavigationContext } from '../../context';
import { HUB_PATH_APP, INSIGHTS_PATH_APP } from '../../routes';
import { createSidebarItem } from '../../utilities/createSidebarItem';
import { SIDEBAR_MODULES_CONFIG } from '../use-app-sidebar/useAppSidebar.config';
import { useWithClientRouting } from '../useWithClientRouting';

export const useSidebarModules = () => {
  const { common } = useAutoneTranslation();
  const { currentPathname } = useNavigationContext();
  const { isAuthorized } = useAuthorization();
  const { releaseTsInsights } = useFlags();
  const withClientRouting = useWithClientRouting();

  return useMemo(
    () => ({
      hub: [
        createSidebarItem({
          config: {
            titleKey: 'sidenav.sections.hub.items.overview.name',
            icon: ElementsIcon,
            path: HUB_PATH_APP.root,
            permissions: [HUB_READONLY],
          },
          common,
          isAuthorized,
          currentPathname,
          withClientRouting,
        }),
      ],
      modules: Object.values(SIDEBAR_MODULES_CONFIG).map((moduleConfig) => {
        const item = createSidebarItem({
          config: moduleConfig,
          common,
          isAuthorized,
          currentPathname,
          withClientRouting,
        });

        if (
          moduleConfig === SIDEBAR_MODULES_CONFIG.insights &&
          releaseTsInsights
        ) {
          return {
            ...item,
            ...withClientRouting(INSIGHTS_PATH_APP.overview),
            subItems: undefined,
          };
        }

        return item;
      }),
    }),
    [
      common,
      isAuthorized,
      currentPathname,
      releaseTsInsights,
      withClientRouting,
    ],
  );
};
